// GENERATED from design/tokens.json — do not edit by hand.
// Regenerate: make design-tokens
//
// What the film may run at. Consumed by code rather than drawn with, so it
// arrives as code — a rate read back out of a CSS custom property would be a
// stylesheet pretending to be a config file.
export const EXPORT = {
  /** The slowest a film may run: the diary's own mini-timelapse cadence. */
  frameRateFloor: 8,
  /** The fastest. Above this a film of faces gains nothing a viewer can see. */
  frameRateCeiling: 30,
} as const;
